export default "__VITE_ASSET__79d70bb9__"